import ApiService from './ApiService'
import type {
    SignInCredential,
    SignUpCredential,
    ForgotPassword,
    ResetPassword,
    SignInResponse,
    SignUpResponse,
} from '@/@types/auth'

export async function apiSignIn(data: SignInCredential) {
    return ApiService.fetchData<SignInResponse>({
        url: '/login',
        method: 'post',
        data,
    })
}

export async function apiSignUp(data: SignUpCredential) {
    return ApiService.fetchData<SignUpResponse>({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut() {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
    })
}

export async function apiForgotPassword(data: ForgotPassword) {
    return ApiService.fetchData({
        url: '/password/forgot',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data: ResetPassword) {
    return ApiService.fetchData({
        url: '/password/reset',
        method: 'post',
        data,
    })
}


export async function apiSendEmailVerify(data: any) {
    return ApiService.fetchData({
        url: "/email/verification-notification",
        method: "post",
        data,
    });
}

export async function apiEmailVerify(data: any) {
    return ApiService.fetchData({
        url: "/user/email/verification",
        method: "post",
        data,
    });
}

export async function apiSignUpOne(data: any) {
    return ApiService.fetchData({
        url: "/admin/signup/step_one",
        method: "post",
        data,
    });
}

export async function apiSignUpTwo(data: any) {
    return ApiService.fetchData({
        url: "/admin/signup/step_two",
        method: "post",
        data,
    });
}

export async function apiSignUpThree(data: any) {
    return ApiService.fetchData({
        url: "/admin/signup/step_three",
        method: "post",
        data,
    });
}

export async function apiPayNow(data: any) {
    return ApiService.fetchData({
        url: "/client/pay",
        method: "post",
        data,
    });
}

export async function apiSignUpForOrg(data: any) {
    return ApiService.fetchData({
        url: `/admin_signup/${data.orgId}/${data.groupId}`,
        method: "get",
    });
}

export async function apiPostSignUpForOrg(data: any) {
    return ApiService.fetchData({
        url: "/admin_login",
        method: "post",
        data,
    });
}
